import React from "react"
import Message from "./message"
import http from "../network/HTTPClient"
class Modal extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...props }
        this.mounted = false
    }
    componentDidMount(e) {
        this.mounted = true
        if (this.state.post !== undefined && this.mounted) {
            e = {
                headers: this.state.post.header !== undefined ? this.state.post.header : this.state.post.headers,
                data: this.state.post.data
            }
            if (e.data === undefined) e.data = {}
            if (e.headers === undefined) e.headers = {}
            e.headers["Access-Control-Allow-Origin"] = "*"
            e.headers.Authorization = "Bearer " + this.state.token
            e.headers.reset = e.headers.reset === undefined ? 0 : e.headers.reset
            http.post(this.state.post.url, e.data)
                .then((response) => {
                    this.closeModal()
                    if (response.data.code * 1 !== 200 && response.data.code !== undefined) {
                        this.state.post.warning(response.data)
                    } else {
                        if (response.data.token !== undefined && response.data.token !== null)
                            http.defaults.headers.common = {
                                Authorization: `Bearer ${response.data.token}`
                            }
                        this.state.post.success(response.data)
                    }
                    if (typeof this.state.post.done === "function") this.state.post.done(response.data)
                })
                .catch((ex) => {
                    this.closeModal()
                    this.state.post.error(ex)
                    if (typeof this.state.post.done === "function") this.state.post.done(ex)
                })

            /*axios({
				method:
					this.state.post.method === undefined
						? "post"
						: this.state.post.method,
				url: this.state.post.url,
				data: e.data,
				headers: e.headers
			})
				.then((response) => {
					this.closeModal()
					if (
						response.data.code * 1 !== 200 &&
						response.data.code !== undefined
					) {
						console.log("warning")
						console.log(response)
						this.state.post.warning(response.data)
					} else {
						console.log("success")
						console.log(response)
						this.state.post.success(response.data)
					}
					if (typeof this.state.post.done === "function")
						this.state.post.done(response.data)
				})
				.catch((ex) => {
					this.closeModal()
					this.state.post.error(ex)
					if (typeof this.state.post.done === "function")
						this.state.post.done(ex)
				})*/
        }
    }
    componentWillUnmount() {
        this.mounted = false
    }
    closeModal = () => {
        if (typeof this.state.closeModal === "function") this.state.closeModal()
    }
    render() {
        if (!this.state.loading && this.state.post === undefined) {
            return (
                <>
                    <div
                        className={"modal-screen"}
                        onClick={() => {
                            setTimeout(() => {
                                if (!this.state.keepModal) this.closeModal()
                                else this.setState({ keepModal: false })
                            })
                        }}
                    >
                        <div
                            className={"modal-deep p-2" + (this.state.backgroundStyle === undefined ? "" : " " + this.state.backgroundStyle)}
                            style={{
                                width: this.state.width,
                                height: this.state.height,
                                backgroundColor: this.state.backgroundColor
                            }}
                            onClick={() => {
                                this.setState({ keepModal: true })
                            }}
                        >
                            {this.state.title !== undefined ? (
                                <div className="alt-font-bold pt-1">
                                    {this.state.title}
                                    <hr className="mt-1 mb-2" />
                                </div>
                            ) : (
                                <></>
                            )}
                            <div className="modal-close" onClick={this.closeModal}>
                                <span className="fa fa-times btn btn-sm btn-danger"></span>
                            </div>
                            {this.state.children}
                        </div>
                    </div>
                    {this.state.message !== undefined && this.state.message !== null ? (
                        <Message mode={this.state.message.mode}>{this.state.message.text}</Message>
                    ) : (
                        ""
                    )}
                </>
            )
        } else {
            return (
                <>
                    <div className="modal-screen">
                        <div className="loader"></div>
                    </div>
                    {this.state.message !== undefined && this.state.message !== null ? (
                        <Message mode={this.state.message.mode}>{this.state.message.text}</Message>
                    ) : (
                        ""
                    )}
                </>
            )
        }
    }
}
export default Modal
